"use client";

import { useEffect } from "react";
import { setCookie } from "utils/cookies";
const PreserveGVRBotInfo = () => {
  useEffect(() => {
    // check the url params for 'verification' and if it is true, then set the cookie
    const params = new URLSearchParams(window.location.search);
    const verification = params.get("verification");
    if (verification === "true") {
      setCookie("verificationBot", "true"); // Save it for a session
    }
  }, []);
  return null;
};
export default PreserveGVRBotInfo;